import type { ComponentProps, ReactNode } from "react";
import { styled } from "styled-components";

import type { StickyGridContextType } from "./context";
import { useStickyGrid } from "./context";

export function StickyGridOverlay({
  children,
  topOffset,
  ...props
}: {
  children: ReactNode | ((context: StickyGridContextType) => ReactNode);
  topOffset?: number;
} & Omit<ComponentProps<typeof StyledStickyGridOverlayWrap>, "children">) {
  const context = useStickyGrid();

  return (
    <StyledStickyGridOverlayWrap {...props}>
      <StyledStickyGridOverlay topOffset={topOffset}>
        {typeof children === "function" ? children(context) : children}
      </StyledStickyGridOverlay>
    </StyledStickyGridOverlayWrap>
  );
}

const StyledStickyGridOverlayWrap = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
`;

const StyledStickyGridOverlay = styled.div<{ topOffset?: number }>`
  position: sticky;
  top: ${({ topOffset }) => topOffset ?? 0}px;
  bottom: 0;

  height: calc(100vh - ${({ topOffset }) => topOffset ?? 0}px);
  max-height: 100%;
`;
